import { render, staticRenderFns } from "./PadMessage.vue?vue&type=template&id=30124bd9&"
import script from "./PadMessage.vue?vue&type=script&lang=js&"
export * from "./PadMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports